define(["exports", "../LinterRule", "../l10n"], function (_exports, _LinterRule, _l10n) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.rule = void 0;
  _LinterRule = _interopRequireDefault(_LinterRule);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  const name = "check-charset";
  const meta = {
    en: {
      description: "Document must only contain one `<meta>` tag with charset set to 'utf-8'",
      howToFix: "Add this line in your document `<head>` section - `<meta charset=\"utf-8\">` or set charset to \"utf-8\" if not set already."
    }
  }; // Fall back to english, if language is missing

  const lang = _l10n.lang in meta ? _l10n.lang : "en";
  /**
   * Runs linter rule.
   *
   * @param {Object} _ The ReSpec config.
   * @param {Document} doc The document to be checked.
   */

  function linterFunction(_, doc) {
    const metas = doc.querySelectorAll("meta[charset]");
    const val = [];

    for (const meta of metas) {
      val.push(meta.getAttribute("charset").trim().toLowerCase());
    }

    const utfExists = val.includes("utf-8"); // only a single meta[charset] and is set to utf-8, correct case

    if (utfExists && metas.length === 1) {
      return [];
    } // if more than one meta[charset] tag defined along with utf-8
    // or
    // no meta[charset] present in the document


    return _objectSpread({
      name,
      occurrences: metas.length
    }, meta[lang]);
  }

  const rule = new _LinterRule.default(name, linterFunction);
  _exports.rule = rule;
});
//# sourceMappingURL=check-charset.js.map